import { EntradaNumero } from "./EntradaNumero";
import { useCallback, useEffect, useState, type FormEvent } from "react";
import { ArrowLeftRight } from "lucide-react";
import { api, dinero, hoy } from "./servicios";
type Perfil = "camila" | "emilio";
type Transferencia = {id:string;fecha:string;origen:Perfil;destino:Perfil;monto_centavos:number;nota:string};
type Datos = {socios:Record<Perfil,{disponibleAhoraCentavos:number}>;transferencias:Transferencia[];hayMas:boolean};
const nombre=(id:Perfil)=>id==="camila"?"Camila":"Emilio";

export function Transferencias({usuario,revision,onTransferir}:{usuario:Perfil;revision:string;onTransferir:()=>Promise<void>}) {
  const [abierto,setAbierto] = useState(false);
  const [datos,setDatos] = useState<Datos|null>(null);
  const [origen,setOrigen] = useState<Perfil>(usuario);
  const [monto,setMonto] = useState("");
  const [fecha,setFecha] = useState(hoy());
  const [nota,setNota] = useState("");
  const [mensaje,setMensaje] = useState("");
  const [ocupado,setOcupado] = useState(false);
  const [pagina,setPagina] = useState(0);
  const [solicitudId,setSolicitudId] = useState(()=>crypto.randomUUID());
  const destino = origen==="camila"?"emilio":"camila";
  const cargar = useCallback(async (p=0) => {
    setOcupado(true);
    try {
      const d=await api<Datos>(`/api/transferencias-socios?pagina=${p}`);
      setDatos(prev=>({...d,transferencias:p&&prev?[...prev.transferencias,...d.transferencias]:d.transferencias}));setPagina(p);
    }catch(e){setMensaje((e as Error).message);}
    finally{setOcupado(false);}
  },[]);
  useEffect(()=>{if(abierto)void cargar();},[abierto,cargar,revision]);
  async function guardar(e:FormEvent){
    e.preventDefault();
    if(ocupado)return;
    const cantidad=Math.round(Number(monto)*100);
    if(!window.confirm(`¿Transferir ${dinero(cantidad)} del disponible de ${nombre(origen)} a ${nombre(destino)}?`))return;
    setOcupado(true);setMensaje("");
    try{
      await api("/api/transferencias-socios",{method:"POST",body:JSON.stringify({solicitudId,origen,montoCentavos:cantidad,fecha,nota})});
      setSolicitudId(crypto.randomUUID());
      setMonto("");setNota("");setMensaje("Transferencia guardada correctamente.");
      await cargar();await onTransferir();
    }catch(e){setMensaje((e as Error).message);await cargar();}
    finally{setOcupado(false);}
  }
  return <section className="transferencias-socios">
    <button className="boton-tabla-financiera" aria-expanded={abierto} onClick={()=>setAbierto(!abierto)}><span><ArrowLeftRight size={19}/>Transferir entre perfiles</span><span>{abierto?"−":"+"}</span></button>
    {abierto && <div className="panel-transferencias">
      <p className="ayuda-historial">Mueve saldo personal, no dinero físico. Usa el disponible total (efectivo + cuenta) y no cambia las ganancias del negocio.</p>
      <form className="formulario-tarjeta" onSubmit={guardar}>
        <div className="rejilla-campos"><label className="campo"><span>De</span><select value={origen} onChange={e=>setOrigen(e.target.value as Perfil)}><option value="camila">Camila</option><option value="emilio">Emilio</option></select></label><label className="campo"><span>Para</span><input value={nombre(destino)} readOnly/></label></div>
        <p className="aviso-retiro">Disponible de {nombre(origen)}: <strong>{datos?dinero(datos.socios[origen].disponibleAhoraCentavos):"Cargando…"}</strong></p>
        <div className="rejilla-campos"><label className="campo"><span>Monto · MXN</span><EntradaNumero type="number" inputMode="decimal" min=".01" max={(datos?.socios[origen].disponibleAhoraCentavos??0)/100} step=".01" value={monto} onChange={e=>setMonto(e.target.value)} required/></label><label className="campo"><span>Fecha</span><input type="date" value={fecha} onChange={e=>setFecha(e.target.value)} required/></label></div>
        <label className="campo"><span>Nota opcional</span><input value={nota} onChange={e=>setNota(e.target.value)} maxLength={240} placeholder="Motivo de la transferencia"/></label>
        {mensaje && <p role="status" className={mensaje.includes("correctamente")?"mensaje-exito":"mensaje-error"}>{mensaje}</p>}
        <button className="boton-primario" disabled={ocupado||!datos||!Number(monto)}>{ocupado?"Cargando…":"Transferir saldo"}</button>
        {!datos&&!ocupado && <button type="button" className="boton-secundario" onClick={()=>void cargar()}>Reintentar</button>}
      </form>
      <h3>Transferencias entre socios</h3>
      <div className="lista-registros">{datos?.transferencias.map(t=><article key={t.id}><ArrowLeftRight size={18}/><div className="registro-info"><strong>{nombre(t.origen)} → {nombre(t.destino)}</strong><small>{t.fecha}{t.nota?` · ${t.nota}`:""}</small></div><div className="registro-monto"><strong>{dinero(t.monto_centavos)}</strong></div></article>)}</div>
      {datos?.hayMas && <button className="boton-secundario" disabled={ocupado} onClick={()=>void cargar(pagina+1)}>Cargar más transferencias</button>}
    </div>}
  </section>;
}
